import clsx from 'clsx'
import {FC, ReactNode, useState} from 'react'
import {TermsViewerModal} from './TermsViewerModal'
import '../Terms.scss'

type Props = {
  // icon: the small header button; link: inline text, as in a footer or a form.
  variant?: 'icon' | 'link'
  className?: string
  children?: ReactNode
}

/** Opens the terms for reading. The window and its reads exist only while it is open. */
export const TermsViewerButton: FC<Props> = ({variant = 'link', className, children}) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      {variant === 'icon' ? (
        <button
          type='button'
          className={clsx('btn btn-icon', className)}
          aria-label='قوانین و مقررات'
          aria-haspopup='dialog'
          title='قوانین و مقررات'
          onClick={() => setOpen(true)}
          data-testid='terms-viewer-button'
        >
          <i className='las la-file-contract fs-1' aria-hidden='true' />
        </button>
      ) : (
        <button
          type='button'
          className={clsx('btn btn-link p-0 align-baseline mp-terms-link', className)}
          aria-haspopup='dialog'
          onClick={() => setOpen(true)}
        >
          {children || 'قوانین و مقررات'}
        </button>
      )}
      {open && <TermsViewerModal onClose={() => setOpen(false)} />}
    </>
  )
}
